import { useState, useEffect } from 'react';
import axios from 'axios';

const CACHE_KEY = 'abilities_list_cache';
const CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 1 week

export function useAbilitiesList() {
  const [abilities, setAbilities] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (raw) {
        const { data, timestamp } = JSON.parse(raw);
        if (Date.now() - timestamp < CACHE_TTL_MS) {
          setAbilities(data);
          return;
        }
      }
    } catch { /* cache corrupta, ignorar */ }

    axios.get('/api/abilities')
      .then(({ data }) => {
        const names = ['None', ...data.map(a => a.name).sort()];
        setAbilities(names);
        localStorage.setItem(CACHE_KEY, JSON.stringify({ data: names, timestamp: Date.now() }));
      })
      .catch(() => { /* silently fail, quedará vacío */ });
  }, []);

  return abilities;
}
